<template>
  <tabs parent="user_management">
    <tab
        id="users"
        :name="translate('user.many')"
        :href="url+'/users'"
    >
      <UserList
        :role_list="role_list"
        :permission_list="permission_list"
      />
    </tab>

    <tab
        v-if="this.$store.getters.getPermissions?.editRbac === true"
        id="user_roles"
        :name="translate('user.roles.many')"
        :href="url+'/user_roles'"
    >
      <RoleList
        :role_list="role_list"
        :permission_list="permission_list"
      />
    </tab>


  </tabs>
</template>

<script>
import {Tabs, Tab} from 'components/UIComponents/Tabs'
import UserList from './Tabs/UserList/Index.vue'
import RoleList from './Tabs/RolesAndPermissions/RolesAndPermissionsIndex.vue'

export default {
  name: 'UserManagement',
  components:{
    Tab,
    Tabs,
    UserList,
    RoleList
  },
  data () {
    return {
      load: true,
      role_list: [],
      permission_list: []
    }
  },


  computed: {
    url () { return '/user_management' }
  },

  created () {
    if (this.$store.getters.getPermissions?.editRbac === true){
      this.get_roles_list()
    }
  },

  methods: {
    get_roles_list () {
      this.$http.v1.getAllRoles((response) => {

        let role_list = {}
        for (let role in response.data.roles) {
          role_list[role] = response.data.roles[role]
          role_list[role].permissions = response.data.roles[role].permissions.sort()
        }
        this.role_list = role_list

        this.permission_list = response.data.permissions
      })
    },
  },
}
</script>
